import { render, staticRenderFns } from "./CampusLife.vue?vue&type=template&id=f41efe12&scoped=true&"
import script from "./CampusLife.vue?vue&type=script&lang=js&"
export * from "./CampusLife.vue?vue&type=script&lang=js&"
import style0 from "./CampusLife.vue?vue&type=style&index=0&id=f41efe12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41efe12",
  null
  
)

export default component.exports